import { Module } from 'vuex';
import {
  action,
  actionCreatorFactory,
  combineAction,
  combineMutation,
  mutation,
} from 'vuex-typescript-fsa/lib';
import { RootState } from '@/store';
import {
  CreateCvSectionGalleryItemRequest,
  CvSectionGallery,
  CvSectionGalleryItem,
  CvSectionGalleryItemResponse,
  CvSectionGalleryResponse,
} from '@/../gen';

export const namespace = 'cvSectionGalleryItemNew';
const actionCreator = actionCreatorFactory(namespace);

export const GetCvSectionGallery = actionCreator<{
  params: {
    cv_id: number;
    id: number;
  };
}>('GET_CV_SECTION_GALLERY');
export const SetCvSectionGallery = actionCreator<CvSectionGalleryResponse>(
  'SET_CV_SECTION_GALLERY'
);
export const SetCvSectionGalleryItem = actionCreator<
  CvSectionGalleryItemResponse
>('SET_CV_SECTION_GALLERY_ITEM');
export const CreateCvSectionGalleryItem = actionCreator<{
  params: {
    cv_id: number;
    cv_section_gallery_id: number;
  };
  body: CreateCvSectionGalleryItemRequest;
}>('CREATE_CV_SECTION_GALLERY_ITEM');
export const ResetState = actionCreator<null>('RESET_STATE');

export interface State {
  cvSectionGallery: CvSectionGallery;
  cvSectionGalleryItem: CvSectionGalleryItem;
}

const initialState = (): State => {
  return { cvSectionGallery: null, cvSectionGalleryItem: null };
};

export const module: Module<State, RootState> = {
  namespaced: true,
  state: initialState,
  actions: combineAction(
    action(GetCvSectionGallery, async function(context, action) {
      const { data } = await this.proffApi.getCvSectionGallery(
        action.payload.params.cv_id,
        action.payload.params.id
      );
      context.commit(SetCvSectionGallery(data.data));
    }),
    action(CreateCvSectionGalleryItem, async function(context, action) {
      const {
        title,
        page_break,
        position,
        description,
        _url,
        image,
      } = action.payload.body;
      const { data } = await this.proffApi.createCvSectionGalleryItem(
        action.payload.params.cv_id,
        action.payload.params.cv_section_gallery_id,
        title,
        page_break,
        position,
        description,
        _url,
        image
      );
      context.commit(SetCvSectionGalleryItem(data.data));
    }),
    action(ResetState, function(context, action) {
      context.commit(ResetState(action.payload));
    })
  ),
  mutations: combineMutation(
    mutation(SetCvSectionGallery, (state, action) => {
      state.cvSectionGallery = action.payload?.attributes;
    }),
    mutation(SetCvSectionGalleryItem, (state, action) => {
      state.cvSectionGalleryItem = action.payload?.attributes;
    }),
    mutation(ResetState, state => {
      Object.assign(state, initialState());
    })
  ),
  getters: {
    cvSectionGallery: state => state.cvSectionGallery,
    cvSectionGalleryItem: state => state.cvSectionGalleryItem,
  },
};
